import _ from 'lodash';
import {apiFetch, apiSearch} from '../utility';

const apiBase = 'trueUpInvoice';
//const plural = 'trueUpInvoices';
//const word = 'true up invoices';

export const search = (p = {}) => {
	const {
		afterDate,
		callback = _.noop
	} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			params : {
				afterDate
			},
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getEmailInfo = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.getEmailInfo`,
			params,
			dispatch,
			callback,
		});
	};
};

export const publicGet = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'trueUpInvoiceIds',
			params,
			dispatch,
			//successMessage : `The ${word} was created successfully.
			//	Click continue to return to the ${word} page.`,
			//onSuccessRedirectTo : `/accounting/${plural}`,
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};


export const send = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.send`,
			params,
			dispatch,
			callback
		});
	};
};

export const invalidate = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.invalidate`,
			params,
			dispatch,
			callback,
		});
	};
};

/*
export const searchLogs = ({bulkInvoiceId, callback = _.noop}) => {
	return dispatch => {
		apiSearch({
			method : 'bulkInvoice.log.search',
			base : 'bulkInvoiceLog',
			keyBy : bulkInvoiceId,
			params : {
				bulkInvoiceId,
			},
			dispatch,
			callback,
		});
	};
};
*/